import { useEffect, useRef } from 'react';
import { useStore } from '@/hooks/useStore';
import { AppShellSkeleton } from '@/components/common/skeletons';
import { logout } from '@/utils/handleLoginResponse';

/**
 * Logout page
 * Logs the user out of the CRM portal, clears stored auth state, then redirects to login.
 */
export default function LogoutPage() {
  const { authStore } = useStore();
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    logout(authStore);
  }, [authStore]);

  return <AppShellSkeleton />;
}
